import React, {useCallback} from 'react'
import {AnimatePresence} from 'framer-motion'

import {
  BackwardButton,
  ButtonsWrapper,
  ForwardButton,
  IconComponent
} from './styles'

interface Props {
  currentIndex: number
  totalPages: number
  goToSlide: (i: number) => void
  showPaginationButtons: boolean
}

export const PaginationButtons = ({
  showPaginationButtons,
  currentIndex,
  goToSlide,
  totalPages
}: Props) => {
  const goToPrevPage = useCallback(
    (e: React.SyntheticEvent) => {
      e.stopPropagation()
      goToSlide(currentIndex > 0 ? currentIndex - 1 : totalPages - 1)
    },
    [currentIndex, goToSlide, totalPages]
  )

  const goToNextPage = useCallback(
    (e: React.SyntheticEvent) => {
      e.stopPropagation()
      goToSlide(currentIndex < totalPages - 1 ? currentIndex + 1 : 0)
    },
    [currentIndex, goToSlide, totalPages]
  )

  return (
    <AnimatePresence>
      {showPaginationButtons && (
        <ButtonsWrapper
          initial={{opacity: 0}}
          animate={{opacity: 1}}
          exit={{opacity: 0}}
        >
          <BackwardButton
            dataId="paginationLeftButton"
            iconStart={<IconComponent name="ChevronLeft" />}
            size="sm"
            variant="secondary"
            isFloating
            isRounded
            onClick={goToPrevPage}
          />

          <ForwardButton
            dataId="paginationLRightButton"
            iconStart={<IconComponent name="ChevronRight" />}
            size="sm"
            variant="secondary"
            isFloating
            isRounded
            onClick={goToNextPage}
          />
        </ButtonsWrapper>
      )}
    </AnimatePresence>
  )
}
